import { ComboboxItem } from '@oncolens/oncolens-ui/lib/components/FormControls/Combobox/Combobox';
import {
  BiomarkerPanelType,
  PanelDropdownItemDto,
} from '@oncolens/oncolens-ui/lib/components/BiomarkerResults/BiomarkerResults.api';

export function formatReportDataForSelectItem(data: PanelDropdownItemDto[]): ComboboxItem[] {
  return data.map((item) => {
    const reportDate = item.panel?.reportDate || item.reportDate;

    const titleParts: string[] = [reportDate ? reportDate.toLocaleDateString() : 'No report date'];
    if (item.type === BiomarkerPanelType.Panel) {
      if (item.panel?.panelName) {
        titleParts.push(item.panel?.panelName);
      }
      if (item.panel?.collectionSite) {
        titleParts.push(item.panel?.collectionSite);
      }
    } else if (item.type === BiomarkerPanelType.PanelOrder) {
      if (item.panelOrder?.panelName) {
        titleParts.push(item.panelOrder?.panelName);
      }

      if (item.panelOrder?.accessionNumber) {
        titleParts.push(item.panelOrder?.accessionNumber);
      }

      if (item.panelOrder?.collectionSite) {
        titleParts.push(item.panelOrder?.collectionSite);
      }
    }

    const label = titleParts.join(' - ');

    return {
      label,
      value: item.panel?.id || item.panelOrder?.id || label
    };
  });
}
